export const DOCUMENT_TYPE_ABOUT_PAGE = 'about-page';
